import type React from 'react';
import {
  Breadcrumbs,
  Panel,
  PanelBody,
  PanelHeader
} from '@itandi/itandi-bb-ui';
import Link from 'next/link';
import { VendorSettingLayout } from '~/components/common/layouts/settings/VendorSettingLayout';
import { VendorLayoutV2 } from '~/components/common/layouts/VendorLayoutV2';
import SettingStyles from '../SettingStyle.module.scss';
import { CompanySettingList } from './CompanySettingList';
import { PATH } from '~/pages/vendors/settings';

export const Page: React.FC = () => (
  <VendorLayoutV2>
    <VendorSettingLayout>
      <div className={SettingStyles.SpBreadcrumbsWrapper}>
        <Breadcrumbs
          items={[
            { label: '設定一覧', as: Link, href: PATH },
            { label: '提携中の管理会社一覧' }
          ]}
        />
      </div>
      <Panel>
        <PanelHeader title="提携中の管理会社一覧" />
        <PanelBody>
          <CompanySettingList />
        </PanelBody>
      </Panel>
    </VendorSettingLayout>
  </VendorLayoutV2>
);
